module.exports = __webpack_public_path__ + "static/img/ao.cdec2b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/ao.jpg
// module id = +gS/
// module chunks = 0